module.exports = __webpack_public_path__ + "static/media/upload_file.aa2766e6.svg";